import { Button } from '@uhg-abyss/web/ui/Button';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Text } from '@uhg-abyss/web/ui/Text';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { adobeLinkTrackEvent } from '../../../../../../../common/AdobeTagging/adobeLinkTrackEvent';
import { adobeCompareDrawerLinkLocation } from '../../utility/compareDrawerConstants';

type Props = {
  isExpandedCardOpen: boolean;
  selectedCount: number;
  setIsExpandedCardOpen: Function;
  setIsCompareViewOpen: Function;
  isCompareViewOpen: Boolean;
  showMergedCompareAndShare?: Boolean;
  setIsCompareClicked?: Function;
};
export const CompareButton = ({
  isExpandedCardOpen,
  selectedCount,
  setIsExpandedCardOpen,
  setIsCompareViewOpen,
  isCompareViewOpen,
  showMergedCompareAndShare,
  setIsCompareClicked,
}: Props) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (selectedCount < 2) {
      setIsCompareViewOpen(false);
    }
  }, [selectedCount]);

  const handleCompareOrUpdateClick = () => {
    setIsCompareClicked?.(true);
    if (showMergedCompareAndShare) {
      adobeLinkTrackEvent({
        name: 'Compare',
        location: 'Compare providers overlay',
        type: 'Internal',
      });
    } else {
      adobeLinkTrackEvent({
        name: `${
          isCompareViewOpen && isExpandedCardOpen
            ? 'update button'
            : 'compare button'
        }`,
        location: `modal:${adobeCompareDrawerLinkLocation}`,
        type: 'internal',
      });
    }

    if (isCompareViewOpen && isExpandedCardOpen) {
      setIsCompareViewOpen(false);
      setIsExpandedCardOpen(false);
    } else {
      setIsExpandedCardOpen(true);
      if (setIsCompareViewOpen) {
        setIsCompareViewOpen(true);
      }
    }
  };

  return (
    <Button
      css={{
        'abyss-button-root': {
          '@media (max-width: 464px)': {
            padding: '12px 15px',
            margin: '13px auto 16px auto',
            backgroundColor:
              selectedCount > 0
                ? '$core.color.brand.100'
                : '$core.color.neutral.10',
            height: '42px',
            borderRadius: '24px',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
          },
          '@media (min-width: 465px)': {
            marginTop: '12px',
            marginLeft: '24px',
          },
          margin: showMergedCompareAndShare ? 0 : undefined,
        },
      }}
      data-auto-testid="compare-drawer-compare-button"
      data-testid="compare-drawer-compare-button"
      isDisabled={selectedCount < 2}
      onClick={handleCompareOrUpdateClick}
      variant="filled"
    >
      <Text
        css={{
          'abyss-text-root': {
            fontSize: '$md',
            paddingLeft: '5px',
            fontWeight: '600',
            lineHeight: '18px',
            textAlign: 'center',
            color: selectedCount > 1 ? '$core.color.neutral.0' : '#929496',
          },
        }}
      >
        {isCompareViewOpen && isExpandedCardOpen
          ? t('Update provider selections')
          : `${t('COMPARE_BUTTONS.COMPARE')} (${selectedCount})`}
      </Text>
      {showMergedCompareAndShare && (
        <IconSymbol
          color="white"
          css={{ paddingTop: '3px' }}
          icon="chevron_right"
        />
      )}
    </Button>
  );
};
